import { createReducer } from "reduxsauce"
import actionCreator from "helpers/actionCreator"

export const { Types, Creators } = actionCreator("ompnt/modules/compareTopicSummary/", {
  setGroup: ["group"],
})

const DEFAULT_STATE = {
  selectedGroup: null,
}

function handleSetGroup(state, { group }) {
  return { ...state, selectedGroup: group }
}

export default createReducer(DEFAULT_STATE, {
  [Types.SET_GROUP]: handleSetGroup,
})
